import {
  Box, Link, LogoMark, Text,
} from '@domain-group/suit-theme'

import systemBrandPayload from '@components/systemBrands/default'

interface RealhubFooterParam {
  disclaimer?: string,
  url?: string,
}

const { logoMark: { logoKey } } = systemBrandPayload

const MediaReviewerFooter = (params: RealhubFooterParam) => {
  const { url = 'https://www.realhub.com.au', disclaimer } = params

  return (
    <Box
      as="footer"
      backgroundColor="bodyFontColor"
      flexDirection="row"
      height={disclaimer?.length ? 'fit-content' : 80}
      paddingY="xlarge"
      variant="center"
    >
      <Box flex={2.5} justifyContent="start" paddingLeft="xlarge" flexWrap="wrap">
        <Text color="white" fontSize="xsmall" lineHeight="1.25">
          {disclaimer}
        </Text>
      </Box>

      <Box flex={0.5} justifyContent="end" paddingRight="xlarge">
        <Link href={url}>
          <LogoMark height={45} width={45} fillColor="white" logoKey={logoKey} />
        </Link>
      </Box>
    </Box>

  )
}

export default MediaReviewerFooter
